﻿import React, { useContext, lazy, useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { isMobileOnly } from 'react-device-detect';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';

import Module_View_Toggler from '@Modules/Module_View_Toggler';
import Bulletin_Board_Module from '@Modules/Bulletin_Board_Module';
import Team_Module from '@Modules/Team_Module';

const Calendar = lazy(() => import('@Modules/Calendar'));
const Timelog_Table_Module = lazy(() => import('@Modules/Timelog_Table_Module'));
const Pomodoro_Timer = lazy(() => import('@Modules/Pomodoro'));
const ClientWebsite_Errors_Module = lazy(() => import('@Modules/ClientWebsite_Errors_Module'));
const Usual_Projects_Module = lazy(() => import('@Modules/UsualProjects_Module'));
const All_Projects_Module = lazy(() => import('@Modules/AllProjects_Module'));

export default function Startpage(): JSX.Element {
    const [t] = useTranslation();
    const { logged_in_user }: context_type = useContext(Context);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 845 || isMobileOnly);

    // CHECKS SCREEN SIZE AND SETS ISMOBILE STATE
    useEffect(() => {
        let timeoutId: NodeJS.Timeout | null = null;
    
        const handleResize = () => {
            if (!timeoutId) {
                timeoutId = setTimeout(() => {
                    setIsMobile(window.innerWidth < 845);
                    timeoutId = null;
                }, 200);
            }
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>{`${t('Navigation.Home')} - InTime`}</title>
            </Helmet>
            <div className="Page_Content_Grid">
                <section className="Page_Content_Grid_Section">
                    <Module_View_Toggler
                        default_module={isMobile ? 1 : 0}
                        module_one={<Calendar />}
                        module_two={<Timelog_Table_Module />}
                        module_one_settings={{
                            icon: <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="calendar" className="svg-inline--fa fa-calendar fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#fff" d="M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"></path></svg>,
                            name: t('Text.Calendar'),
                            module_identifier: 0
                        }}
                        module_two_settings={{
                            icon: <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="list" className="svg-inline--fa fa-list fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg>,
                            name: t('Text.List'),
                            module_identifier: 1
                        }}
                    />
                    {
                        logged_in_user?.settings?.displayClientWebsiteErrors &&
                        <ClientWebsite_Errors_Module />
                    }
                </section>
                <section className="Page_Content_Grid_Section">
                    {
                        logged_in_user?.settings?.displayPomodoro &&
                        <Pomodoro_Timer />
                    }
                    <Bulletin_Board_Module />
                    {
                        logged_in_user?.settings?.displayModuleRecentProjects &&
                        <Usual_Projects_Module />
                    }
                    {
                        logged_in_user?.settings?.displayModuleAllProjects &&
                        <All_Projects_Module />
                    }
                    <Team_Module />
                    
                </section>
            </div>
        </>
    );
}